import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c472dec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "careersheet_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "careersheet_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "careersheet_title_text" }, "プログラミング言語の編集")
], -1))
const _hoisted_3 = { class: "careersheet_input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "プログラミング言語（複数選択可）")
], -1))
const _hoisted_5 = { class: "careersheet_input_layout_column_1" }
const _hoisted_6 = { class: "careersheet_button" }
const _hoisted_7 = { class: "careersheet_button_prev" }
const _hoisted_8 = { class: "careersheet_button_next" }

import BaseButton from '@/components/BaseButton.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import { ref, Ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import store from '@/store';
import alertOnReload from '@/utils/alertOnReload';


export default /*#__PURE__*/_defineComponent({
  __name: 'SkillPclanguageEditView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const usableLanguageList: Ref<{ label: string; value: boolean; key: string }[]> = ref(
  store.getters['careerSheetPclanguage/usableLanguageList']
);

const transitionConfirmPage = () => {
  store.commit('careerSheetPclanguage/setUsableLanguageList', usableLanguageList.value);
  if (route.query.ref === 'e') {
    router.push({ name: 'e60', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e60' });
  }
};

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e50', query: { ref: 'e' } });
  } else {
    router.push({ name: 'n50' });
  }
};

alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usableLanguageList.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.label,
            class: "careersheet_input_layout_column_1_item"
          }, [
            _createVNode(BaseCheckbox, {
              value: false,
              label: item.label,
              modelValue: item.value,
              "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
            }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(BaseButton, {
          theme: "tertiary",
          type: "button",
          onClick: transitionPreviousPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("戻る")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(BaseButton, {
          theme: "primary",
          type: "button",
          onClick: transitionConfirmPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("確認する")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})